<template>
  <div class="wholeContext">
    <div class="appContext loginPage">
      <div class="container">
        <div class="logoWrap">
          <router-link to="/">
            <div class="symbol">
              <img src="@/assets/images/logo.svg">
            </div>
          </router-link>
            <div class="logoText">
              <img src="@/assets/images/logo_t.svg">
            </div>

        </div>
        <div class="noti">
          <div class="textWrap">
            <p>갑상선암-두경부암 진단과 <b>수</b><b>술</b>에 특화된 병원입니다.</p>
            <p>이비인후과(갑상선-두부외과), 외과(갑상선-내분비외과),</p>
            <p>내과(갑상선-내분비내과),</p>
            <p>마취통증의학과 전문의들이 진료합니다.</p>
            <p>단순 감기나 귀 질환, 코 질환 진료는 하지 않습니다.</p>
          </div>
        </div>
        <div class="login">
          <form @submit.prevent="submitForm">
            <div class="inputWrap">
              <input type="text" placeholder="아이디"  v-model ="id"/>
            </div>
            <div class="inputWrap">
              <input type="password" placeholder="비밀번호" v-model="password"/>
            </div>
            <div class="switch_wrap" v-if="getDeviceDeviceId">
              <label class="switch">
                <input type="checkbox" id="loginPeriod" v-model="autoLogin" @click="loginAuto()">
                <span class="slider round"></span>
              </label>
              <p>자동로그인</p>
            </div>
            <div class="loginFunction">
              <div class="buttonWrap">
                <button type="submit">로그인</button>
              </div>
              <ul class="hyperlink">
                <li><router-link to="./ChoiceType">회원가입</router-link></li>
                <li><router-link to="./idFind">아이디 찾기</router-link></li>
                <li><router-link to="./isTemp">비밀번호 찾기</router-link></li>
              </ul>
            </div>
          </form>
        </div>
        <ul class="userRights">
          <li><router-link to="./privacy">개인정보처리방침</router-link></li>
          <li><router-link to="./terms">회원약관</router-link></li>
          <li><router-link to="./patient">환자의 권리와 의무</router-link></li>
        </ul>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
// import AppSidebar from '../components/AppSidebar'
// import AppHeaderOnlyLogin from '../components/AppHeaderOnlyLogin'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import {
  getCookie
} from '../utils/cookieNew'
import EventBus from '../utils/bus'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      id: '',
      password: '',
      errorMessage: '',
      joinLink: './ChoiceType',
      idFindLink: './idFind',
      passwordFindLink: './isTemp',
      tokenData: '',
      cookie: '',
      setCount: false,
      autoLogin: false,
      getDeviceFcmToken: '',
      getDeviceDeviceId: '',
      getDeviceDevice: '',
      getDeviceAppVersion: ''
    }
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters('push', [
      'getPushCounted'
    ]),
    ...mapGetters([
      'GET_PUSH_LIST'
    ])
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    /* 배경색 클래스 추가 */
    document.body.classList.add('loginBody')
    if (sessionStorage.getItem('authErrorCause') !== null) {
      this.logOutAction()
    } else {
      if (getCookie('token') !== undefined) {
        console.log('이미 로그인했으므로 메인페이지로 리다이렉트 합니다. ')
        this.$router.push('/')
      }
      /* 모바일로 진입시 */
      if (getCookie('deviceId') !== undefined) {
        console.log('callBackDeviceInfo에서 받은 데이터셋이 존재합니다.')
        this.fetchMobileProps()
      }
    }
    console.log('하이퍼경로', sessionStorage.getItem('pathToLoadAuthPre'))
    console.log('권없경로', sessionStorage.getItem('pathToLoadUnAuth'))
    console.log('권필경로', sessionStorage.getItem('pathToLoadAuth'))
  },
  mounted () {
    EventBus.$emit('pageAccess', true)
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('push', [
      'SET_PUSHCOUNTED'
    ]),
    async logOutAction () {
      try {
        await this.LOGOUT_USER()
          .then(() => {
            console.log('로그아웃이 정상적으로 처리됨')
            EventBus.$emit('logoutEvent', true)
          })
      } catch (error) {
        console.log('로그인 -로그아웃에서 에러남')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else if (sessionStorage.getItem('authErrorCause') !== 'mutated') {
          this.SET_POPUP(true)
          this.popupSet.content = '권한이 없거나 만료되었습니다. 로그인해주세요'
          this.popupSet.mobileLink = '/login'
          this.popupSet.count = 'mobileDeleteAuth'
          this.popupSet.closeType = 'mobileDeleteAuth'
        } else {
          if (sessionStorage.getItem('userAgent') === 'mobile') {
            const url = 'thanq://logout'
            document.location.href = url
          }
          sessionStorage.removeItem('authErrorCause')
        }
      } finally {
      }
    },
    async patchPushList () {
      console.log('푸시리스트 api 실행 (로그인에서)')
      try {
        await this.PUSH_LIST()
          .then(() => {
            this.patchData()
          })
      } catch (error) {
        console.log('error :', error);
        console.log('푸시리스트 api 에러에 진입함!')
        console.log('푸시실패 처리 후 이동경로', sessionStorage.getItem('pathToLoadAuthPre'))
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    patchData () {
      const InactivityArray = []
      let count = 0
      for (let i = 0; i < this.GET_PUSH_LIST.length; i++) {
        // 읽지않은 푸시 담기
        if (this.GET_PUSH_LIST[i].is_read === false) {
          InactivityArray.push(String(i))
          // 뱃지카운트 계산해
          count++
        }
      }
      console.log('뱃지카운트 구하는데 진입')
      this.SET_PUSHCOUNTED(count)
    },
    async fetchMobileProps () {
      this.getDeviceFcmToken = getCookie('fcmToken')
      this.getDeviceDeviceId = getCookie('deviceId')
      this.getDeviceAppVersion = getCookie('appVersion')
      this.getDeviceDevice = getCookie('device')
      console.log('===CallbackDeviceInfo 받아온값===')
      console.log('디바이스정보', this.getDeviceFcmToken + this.getDeviceDeviceId + this.getDeviceAppVersion + this.getDeviceDevice)
      this.autoLogin = true
    },
    submitForm () {
      if (this.id === '' || this.password === '') {
        this.SET_POPUP(true)
        this.popupSet.content = '아이디 또는 비밀번호를 입력해주세요.'
        return false
      }
      if (sessionStorage.getItem('userAgent') !== 'mobile') {
        this.loginUser()
      } else {
        this.loginMobile()
      }
    },
    async loginUser () {
      try {
        const userData = {
          id: this.id,
          password: this.password
        }
        await this.LOGIN_USER(userData)
          .then(() => {
            this.patchPushList()
          })
      } catch (error) {
        console.log('error :', error);
        console.log('로그인 에러 진입함')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          if (error.data.response.message === 'Incorrect Id or Password') {
            this.popupSet.content = '아이디 또는 비밀번호가 잘못되었습니다.'
          } else if (error.status === 500) {
            this.popupSet.content = '서버 내부의 오류로 로그인할 수 없습니다.'
          } else {
            this.popupSet.content = errorParser.parse(error)
          }
        } else {
          await this.$router.push('/login')
        }
      } finally {
        this.initForm()
      }
    },
    async loginMobile () {
      try {
        const userDataDesktop = {
          id: this.id,
          password: this.password,
          deviceId: this.getDeviceDeviceId,
          fcmToken: this.getDeviceFcmToken,
          device: this.getDeviceDevice
        }
        console.log('===로그인모바일출력===')
        console.log('deviceId', userDataDesktop.deviceId)
        console.log('fcmToken', userDataDesktop.fcmToken)
        console.log('device', userDataDesktop.device)
        await this.LOGIN_USER(userDataDesktop)
          .then(() => {
            this.patchPushList()
            console.log('로그인 후 발행된 sessionToken', getCookie('token'))
            const autoLogin = this.autoLogin
            const sessionToken = getCookie('token')
            const url = 'thanq://login?sessionToken=' + sessionToken + '&autoLogin=' + autoLogin
            document.location.href = url
          })
      } catch (error) {
        console.log('error :', error);
        console.log('체크리스트 디테일 에러에 진입함!')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          if (error.data.response.message === 'Incorrect Id or Password') {
            this.popupSet.content = '아이디 또는 비밀번호가 잘못되었습니다.'
          } else if (error.status === 500) {
            this.popupSet.content = '서버 내부의 오류로 로그인할 수 없습니다.'
          } else {
            this.popupSet.content = errorParser.parse(error)
          }
        } else {
          await this.$router.push('/login')
        }
      } finally {
        this.initForm()
      }
    },
    callPrev () {
      const currentLocation = document.location.href
      const mainLocate = currentLocation.substring(currentLocation.length, currentLocation.length - 6)
      if (sessionStorage.getItem('pathToLoadUnAuth') === mainLocate) {
        if (this.setCount) {
          this.$router.push('/')
        } else {
          history.go(1)
        }
        this.setCount = true
        // 클로즈 함수 구현
      }
    },
    ...mapActions([
      'LOGIN_USER',
      'PUSH_LIST',
      'LOGOUT_USER'
    ]),
    /* 자동로그인 토큰 보유기간 늘리기 */
    loginAuto () {
      this.autoLogin = !this.autoLogin
    },
    /* 폼(데이터 필드) 초기화 */
    initForm () {
      this.id = ''
      this.password = ''
    }
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
    EventBus.$off('pageAccess')
    /* 배경색 클래스 제거 */
    document.body.classList.remove('loginBody')
  },
  components: {
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/css/auth/login";
</style>
